import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/registrations";

export const BULK_UPLOAD_ENDPOINT = `${BASE}/bulk-upload`;

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(data) {
  return axios.post(BASE, data);
}

export function myCourses(body = {}) {
  return axios.post(`${BASE}/my-courses`, body);
}

export function teacherPaidPeriods(data) {
  return axios.post(`${BASE}/teacher-paid-periods`, data);
}

export function update(id, data) {
  return axios.patch(`${BASE}/${id}`, data);
}

export function updateCourseDiscounts(id, data) {
  return axios.post(`${BASE}/${id}/update-course-discounts`, data);
}

export function transfer(id, data) {
  return axios.post(`${BASE}/${id}/transfer`, data);
}

export function dropPreview(id, data) {
  return axios.post(`${BASE}/${id}/drop-preview`, data);
}

export function drop(id, data) {
  return axios.post(`${BASE}/${id}/drop`, data);
}

export function addBack(id, data) {
  return axios.post(`${BASE}/${id}/add-back`, data);
}

export function writeOffResidual(id, periodId) {
  return axios.post(`${BASE}/${id}/fee-periods/${periodId}/write-off-residual`);
}

export function dropByStudent(id, data) {
  return axios.post(`${BASE}/${id}/drop-by-student`, data);
}

export function addCourse(id, data) {
  return axios.post(`${BASE}/${id}/add-course`, data);
}

export function uploadFeeImage(id, formData) {
  return axios.post(`${BASE}/${id}/upload-fee-image`, formData);
}
